import { combineReducers } from "redux";
import { AUTH_ACTION_TYPES } from "../actions/types";
import creatorReducer from "./creatorReducer";
import userReducer from "./userReducer";
import authReducer from "./authReducer";
import notificationReducer from "./notificationReducer";
import messageReducer from "./messageReducer";
import discoverReducer from "./discoverReducer";
import contentReducer from "./contentReducer";
import transactionReducer from "./transactionReducer";
import matrixReducer from "./matrixReducer";
import creditReducer from "./creditReducer";
import activityReducer from "./activityReducer";
import tipReducer from "./tipReducer";

const appReducer = combineReducers({
  creator: creatorReducer,
  user: userReducer,
  auth: authReducer,
  notifications: notificationReducer,
  messages: messageReducer,
  discover: discoverReducer,
  content: contentReducer,
  transaction: transactionReducer,
  matrix: matrixReducer,
  credit: creditReducer,
  activity: activityReducer,
  tips: tipReducer,
});

// Root reducer that handles RESET_STATE action
const rootReducer = (state, action) => {
  // When RESET_STATE is dispatched, reset all state to undefined
  // which causes all reducers to return their initial state
  if (action.type === AUTH_ACTION_TYPES.RESET_STATE) {
    state = undefined;
  }
  
  return appReducer(state, action);
};

export default rootReducer;
